import {
    CaretDownOutlined, CarOutlined, HomeOutlined,
    LogoutOutlined, MenuOutlined, UserOutlined,
    FileSearchOutlined, InfoCircleOutlined, IdcardOutlined,
} from "@ant-design/icons";
import i18next from "i18next";
import {getSessionData} from "../../utility/global-util";
import {getOnLineStatusFromNavigator} from "../../utility/hooks/useOnlineStatus";


const userDisplayName= () => {
    const displayName = getSessionData('userDisplayName');
    return (displayName);
}

const filterMenuItems = (theMenuItems, mobileMode, permissions, driverNotAllocated) => {

    // Look at special attributes to control if menu currently showing or not
    const correctItems = theMenuItems.filter(itm => {
        if (itm.hasOwnProperty('mobileOnly')) {
            if(!mobileMode)
            {
                return false;
            }
        }
        if (itm.hasOwnProperty('onlineOnly')) {
            if(!getOnLineStatusFromNavigator())
            {
                return false;
            }
        }
        if (itm.hasOwnProperty('notAllocated')) {
            if(itm.notAllocated !== driverNotAllocated)
            { 
                return false;
            }
        }
        if (itm.hasOwnProperty('permission')) {
            return permissions?.includes(itm.permission);
        }
        else {
            return true;
        }
    });

    // Return correct menu items but without the special control attributes (confuses the DOM)
    const returnItems = [];
    if (correctItems && correctItems.length > 0) {
        correctItems.forEach(itm => {
            returnItems.push({ label: itm.label, key: itm.key, icon: itm.icon });
        })
    }
    return returnItems;
}

// ---------------------------------------------------------------------------------------------------------------------------------------------------
// MENU ITEMS (with children if desired for submenu items)
// - *** 'key' matches id on driverRoutes.js in most cases ***
// - special ones like logout coded in MainHeader menuClick()
// - only set optional 'mobileOnly' attribute to "true" to hide that menu item from the desktop menu or "false" to hide that item from the mobile menu
// - only set optional 'onlineOnly' attribute to 'true' to hide that menu item when the app is offline
// - only set optional 'notAllocated' attribute to 'false' to hide that menu item when the driver has no allocated vehicles
// - use optional 'permission' attribute set to a driver portal permission name if that permission is required for that menu item e.g. inspections
// ----------------------------------------------------------------------------------------------------------------------------------------------------

// All menu items added here and controlled below
const sourceMenuItems = (includeDownArrow, mobileMode, permissions, driverNotAllocated) => {

    let baseMenu = [
    {
        label: i18next.t('title.home'),
        key: 'home',
        icon: <HomeOutlined />,
    },
    {
        label: i18next.t('title.vehicle_details'),
        key: 'vehicle-details',
        icon: <CarOutlined />,
        notAllocated: false,
    },
    {
        label: i18next.t('title.inspections'),
        key: 'inspections',
        icon: <FileSearchOutlined />,
        onlineOnly: true,
        notAllocated: false,
        permission: "DRIVERS_PORTAL_CORPORATE_CUSTOMER_INSPECTION",
    },
    /*{
        label: i18next.t('title.maintenance'),
        key: 'maintenance',
        icon: <ToolOutlined />,
        onlineOnly: true,
        notAllocated: false,
    },
    {
        label: i18next.t('title.accidents'),
        key: 'accident',
        icon: <WarningOutlined />,
        onlineOnly: true,
        notAllocated: false,
    },*/
    ]

    const userMenu = [
    {
        label: i18next.t('title.my_details'),
        key: 'contact-details',
        icon: <IdcardOutlined />,
    },
    {
        label: i18next.t('title.info'),
        key: 'info',
        icon: <InfoCircleOutlined />,
        mobileOnly: true,
    },
    {
        label: i18next.t('title.logout'),
        key: 'logout',
        icon: <LogoutOutlined />,
    },
    ]  
    if(includeDownArrow)
    {
       return [
        ...filterMenuItems(baseMenu, mobileMode, permissions, driverNotAllocated),
        {
            label: <span>{userDisplayName()} <CaretDownOutlined /></span>,
            key: 'user',
            icon: <UserOutlined />,
            children: filterMenuItems(userMenu, mobileMode, permissions, driverNotAllocated),
        }]
    }
    else
    {   
        return filterMenuItems([...baseMenu, ...userMenu], mobileMode, permissions, driverNotAllocated);
    }
};

// Main (desktop) Menu
export const mainMenuItems = ({permissions, driverNotAllocated}) => {
    return sourceMenuItems(true, false, permissions, driverNotAllocated);
}

// Mobile (small screen) Menu
export const mobileMenuItems = ({permissions, driverNotAllocated}) => {
    return [
    {
        selected: true,
        icon: <MenuOutlined className="dp-main-menu-vertical-icon" />,
        children: sourceMenuItems(false, true, permissions, driverNotAllocated),
    },
]
}